import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type CloseProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function Close(props: CloseProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="CloseIcon"
      style={style}
    >
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  )
}
